import { Controller } from "@hotwired/stimulus"
import { pdpCommonProps } from "@/lib/pdpAnalytics"
import { artworkOrientation, frameFinish, wallArUri } from "@/lib/wallArUri"

export default class extends Controller {
  static values = {
    src: String,
    art: String,
    width: Number,
    height: Number,
    depth: Number,
    userId: String,
    uid: String,
  }

  connect() {
    this.followFrame()
    this.capture("pdp_view_on_wall_shown")
  }

  followFrame(event) {
    if (event && event.target.name !== "frame") return

    this.element.href = wallArUri(this.srcValue, {
      art: this.artValue,
      width: this.widthValue,
      height: this.heightValue,
      depth: this.depthValue,
      frame: this.selectedFrameFinish(),
    })
  }

  track() {
    this.capture("pdp_view_on_wall_opened")
  }

  capture(event) {
    const galleryData = document.getElementById("product-gallery")?.dataset || {}
    window.posthog?.capture(event, {
      ...pdpCommonProps(galleryData),
      user_id: this.userIdValue ? parseInt(this.userIdValue, 10) : null,
      uid: this.uidValue,
      frame: this.selectedFrameFinish(),
      orientation: artworkOrientation(this.widthValue, this.heightValue),
    })
  }

  selectedFrameFinish() {
    return frameFinish(document.querySelector('input[name="frame"]:checked')?.value)
  }
}
